/* eslint-disable */
import startTab from './defaults/startTab'
import musicTab from './defaults/musicTab'
import { Activity } from '../../../models/activity'

export default {

    setTabStatus(state, status) {
        state.tabStatus = status
    },
    setSavingForm(state, payload) {
        state.savingForm = payload
    },
    setSavingErrorMessage(state, payload) {
        state.savingErrorMessage = payload
    },
    setSaving(state, payload) {
        state.saving = payload
    },
    setEmptyActivity(state) {
        state.currentActivity = {
            "type": 'workout',
            "status": 'draft',
            "series": null,
            "working_title": "",
            "colour": null,
            "file": "",
            "historical_name": "",
            "levels": [],
            "emotion": null,
            "intensity": null,
            "notes": "",
            "location": null,
            "timer_on_screen": null,
            "need_equipment": false,
            "spotify_playlist_name": "",
            "spotify_playlist_link": "",
            "apple_playlist_name": "",
            "apple_playlist_link": "",
            "required_music": true,
            "mode": null,
            "body_part": [],
            "benefit_1": null,
            "benefit_2": null,
            "benefit_3": null,
            "cautions": [],
            "naz_says": "",
            "naz_description": "",
            "need_chapterisation": false,
            "stretch_flow": null,
            "warm_up": null,
            "flag_intensity": 1,
            "flag_internal_notes": null,
            "render": null,
            "pre_production": null,
            "post_production": null
        }
    },
    setEmptyPostProd(state) {
        state.render = {
            "activity": null,
            "title_card": false,
            "rendered": false,
            "uploaded": false,
            "txt_code": "",
            "file_location": "",
            "brightcove_id": "",
            "thumbnail": ""
        },
            state.pre_production = {
                "activity": null,
                "location": null,
                "location_details": "",
                "wardrobe_and_hair": "",
                "filming_notes": ""
            },
            state.post_production = {
                "activity": null,
                "filmed": false,
                "rough_cut": null,
                "review": null,
                "final_cut": null,
                "colour_grade": null,
                "timer": null,
                "file_location": "",
                "project_location": "",
                "edit_notes": "",
                "portrait_thumbnail": null,
                "landscape_thumbnail": null,
                "portrait_video": null,
                "landscape_video": null,
            }
    },
    setFieldOptions(state, options) {
        state.fieldOptions = options
    },
    setWarmupsOptions(state, options) {
        state.warmupsOptions = options
    },
    setStretchFlowsOptions(state, options) {
        state.stretchFlowsOptions = options
    },
    setSidebarOpened(state, { sidebarOpened }) {
        state.sidebarOpened = sidebarOpened
    },
    setActivity(state, payload) {
        state.currentActivity = payload
    },
    setActivityPostProductionValue(state, payload) {
        state.currentActivity.post_production[payload.type] = payload.data
    },

    setActivityStatus(state, payload) {
        state.currentActivity.status = payload
    },
    setActivityField(state, { fieldName, value }) {
        state.currentActivity[fieldName] = value
    },
    setActivityFieldObj(state, { type, fieldName, value }) {
        state.currentActivity[type][fieldName] = value
    },
    setActivityRenderField(state, { fieldName, value }) {
        state.render[fieldName] = value
    },
    setActivityPreProductionField(state, { fieldName, value }) {
        state.pre_production[fieldName] = value
    },
    setActivityPostProductionField(state, { fieldName, value }) {
        state.post_production[fieldName] = value
    },

    setCurrentActivityPostProduction(state, post_production) {
        state.post_production = post_production
    },

    setActivityProductionId(state, type) {
        state[type].activity = state.currentActivity.id
    },
    setEquipmentsCategories(state, categories) {
        state.equipmentsCategories = categories.results
    },
    setEquipment(state, equipment) {
        state.currentEquipment = equipment
    },
    setStartTabValidation(state, errors) {
        let startTabErrors = JSON.parse(JSON.stringify(startTab))
        startTabErrors = Object.assign(startTabErrors, errors)
        state.currentActivityState.startTab = startTabErrors
    },
    setEmptyStartTabValidation(state) {
        state.currentActivityState.startTab = startTab
    },
    setEquipmentTabValidation(state, errors) {
        let equipmentTabErrors = JSON.parse(JSON.stringify(equipmentTab))
        equipmentTabErrors = Object.assign(equipmentTabErrors, errors)
        state.currentActivityState.equipmentTab = equipmentTabErrors
    },
    setMusicTabValidation(state, errors) {
        let musicTabErrors = JSON.parse(JSON.stringify(musicTab))
        musicTabErrors = Object.assign(musicTabErrors, errors)
        state.currentActivityState.musicTab = musicTabErrors
    },
    setEmptyMusicTabValidation(state) {
        state.currentActivityState.musicTab = musicTab
    },
    setOpenedNotes(state, opened) {
        state.notesOpened = opened
    },
    setOpenedApproval(state, opened) {
        state.approvalOpened = opened
    },
    setStatusApproval(state, status) {
        state.approvalStatus = status
    },
    setCurrentFlag(state, flag) {
        state.currentActivity['flag_intensity'] = flag
    },
    setUpdateActivity(state, data) {
        data.activity[data.type] = data.flag
        state.updateActivity = data.activity
    },
    setCurrentList(state, data) {
        state.currentDataList = data
    },
    setEmptyCurrentList(state) {
        state.currentDataList = []
    },
    setType(state, type) {
        state.currentActivity.type = type
    },
    setCurrentPaginationPage: (state, data) => {
        return state.currentPaginationPage = data
    },

    setCurrentWarmup: (state, data) => {
        return state.currentWarmup = data
    },
    setCurrentStretchFlow: (state, data) => {
        return state.currentStretchFlow = data
    },
    setCurrentVideos: (state, videos) => {
        return state.currentVideos = videos.results.slice().reverse()
    },
    setVideoField(state, { index, fieldName, value }) {
        state.currentVideos[index][fieldName] = value
    },
    setUserList(state, data) {
        state.userList = data
    },
    setActivityCurrentTab(state, data) {
        state.activityCurrentTab = data
    },
    setPreloader(state, status) {
        state.preloader = status
    },
    setJourney(state, data) {
        state.journeyList = data
    },
    setJourneyReport(state, data) {
        state.journeyReport = data
    },
}